export default __webpack_public_path__ + "static/media/graphrag-book.150a3ef2.png";